import type { SessionNoteDraft } from '@/api/assistantVoice/assistantVoiceApi.types';

export interface OpenSessionNoteForm {
  patientId: string;
  applyDraft: (draft: SessionNoteDraft) => void;
  saveAsDraft: () => Promise<boolean>;
  hasUnsavedChanges: () => boolean;
}

export class SessionNoteFormRegistry {
  private forms: OpenSessionNoteForm[] = [];

  register(form: OpenSessionNoteForm): () => void {
    this.forms = [...this.forms, form];
    return () => {
      this.forms = this.forms.filter(function keepOthers(candidate) {
        return candidate !== form;
      });
    };
  }

  current(): OpenSessionNoteForm | null {
    const latest = this.forms[this.forms.length - 1];
    return latest === undefined ? null : latest;
  }
}
